import { IconLanguage } from '@tabler/icons-react';
import { Menu, ActionIcon } from '@mantine/core';
import { useIntl } from 'react-intl';
import { useLocale } from '../../contexts';
import { supportedLocales } from '../../locales';

export function LanguageSwitch() {
  const intl = useIntl();
  const { locale: currentLocale, setLocale } = useLocale();

  const handleLanguageChange = (locale: any) => {
    setLocale(locale);
  };

  const languages = supportedLocales.map((code) => ({
    code,
    label: intl.formatMessage({ id: code }),
  }));

  return (
    <Menu trigger="click" transitionProps={{ exitDuration: 0 }} withinPortal>
      <Menu.Target>
        <ActionIcon variant="default" size="md" aria-label="Change language">
          <IconLanguage size={18} stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {languages.map((lang) => (
          <Menu.Item
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            style={{
              fontWeight: currentLocale === lang.code ? 600 : 400,
              backgroundColor:
                currentLocale === lang.code
                  ? 'var(--mantine-color-default-hover)'
                  : undefined,
            }}
          >
            {lang.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
